import { Modal, Button, Form } from 'react-bootstrap';
import { Formik, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import PropTypes from 'prop-types';

const DeleteSchedule = ({
  scheduleInfo,
  showDeleteSchedule,
  handleDeleteScheduleDisplay,
  handleDeleteSchedule,
}) => {
  const validationSchema = () =>
    Yup.object({
      shiftId: Yup.string().nullable(true),
      reason: Yup.string()
        .required('Reason is required')
        .matches(/[a-zA-Z]+/g, 'Reason should be alphanumeric')
        .min(5, 'Reason must be more than 5 characters')
        .max(250, 'Reason must be less than 250 characters'),
    });

  return (
    <Modal
      show={showDeleteSchedule}
      onHide={() => {
        handleDeleteScheduleDisplay(false);
      }}
      centered
      backdropClassName="inner-modal-backdrop"
    >
      <Modal.Header>
        <Modal.Title className="m-0">Delete Schedule?</Modal.Title>
        <button
          type="button"
          className="btn-close"
          aria-label="Close"
          onClick={() => {
            handleDeleteScheduleDisplay(false);
          }}
        />
      </Modal.Header>
      {scheduleInfo && scheduleInfo.extendedProps && (
        <Formik
          initialValues={{
            scheduleId: scheduleInfo.id,
            reason: '',
          }}
          validationSchema={validationSchema}
          onSubmit={(values) => {
            handleDeleteSchedule({
              scheduleId: values.scheduleId,
              reason: values.reason,
            });
          }}
        >
          {(formikprops) => (
            <Form onSubmit={formikprops.handleSubmit}>
              <Modal.Body>
                <section>
                  <Form.Group controlId="reason">
                    <Form.Label>
                      Reason for deletion{' '}
                      <small className="text-muted">(max 250 characters)</small>{' '}
                      <span className="text-danger">*</span>
                    </Form.Label>
                    <Field
                      as="textarea"
                      maxLength="250"
                      name="reason"
                      rows="2"
                      className="form-control"
                      placeholder="e.g. No longer needed, created by mistake, schedule changed"
                    />

                    <ErrorMessage
                      name="reason"
                      render={(msg) => (
                        <small className="text-danger">{msg}</small>
                      )}
                    />
                  </Form.Group>
                </section>
              </Modal.Body>
              <Modal.Footer className="d-flex justify-content-between">
                <Button
                  variant="link"
                  onClick={() => {
                    handleDeleteScheduleDisplay(false);
                  }}
                >
                  Cancel
                </Button>
                <Button variant="danger" className=" ml-auto" type="submit">
                  Yes, delete schedule
                </Button>
              </Modal.Footer>
            </Form>
          )}
        </Formik>
      )}
    </Modal>
  );
};

DeleteSchedule.propTypes = {
  scheduleInfo: PropTypes.object,
  showDeleteSchedule: PropTypes.bool,
  handleDeleteScheduleDisplay: PropTypes.func,
  handleDeleteSchedule: PropTypes.func,
};

export default DeleteSchedule;
